// src/config/api.js
// export const API = "https://api.orbitmart.co.in/api/v1";
export const API = "https://api.orbitmart.co.in/api/v1";